/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ateliere_Connect_Status_Events_ProcessedInputs */



/**
* | output |
* | --- |
* | "{count} events processed..." |
*
* @param {Ateliere_Connect_Status_Events_ProcessedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_events_processed = /** @type {((inputs: Ateliere_Connect_Status_Events_ProcessedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Events_ProcessedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} événements traités...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Ereignisse verarbeitet...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} eventi elaborati...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`События ${i?.count} обработаны...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} eventos procesados...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 事件已处理...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 件のイベントが処理されました...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} इवेंट्स प्रोसेस हो गए...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos ${i?.count} processados...`)
	return /** @type {LocalizedString} */ (`${i?.count} events processed...`)
});